export default __webpack_public_path__ + "static/media/valeo.a96b2c85.png";